// @flow
import { connect } from 'react-redux';
import ohlcvModel, { updateDuration, updateTimeSpan, getBaseSymbol, getDisplayMode } from '../../store/models/ohlcv';

import type { State } from '../../types';

type Props = {
  onCollapse: string => void
}

export const mapStateToProps = (state: State, ownProps: Props) => {
  return {
    displayMode: getDisplayMode(state),
    baseSymbol: getBaseSymbol(state),
    ...ohlcvModel(state).getState(),
    ...ownProps
  }
};

export const mapDispatchToProps = {
  updateDuration,
  updateTimeSpan,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);



// WEBPACK FOOTER //
// ./src/components/OHLCV/connect.js